import FacturaCrud from './FacturaCrud'
export {FacturaCrud}
export default FacturaCrud
